import { Box, styled } from '@mui/material';

export const OptionItemContainer = styled(Box)(({ theme, index }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px 8px',
  borderRight: index < 2 ? '2px solid' : '',
  [theme.breakpoints.down(1300)]: {
    borderBottom: index < 2 ? '2px solid' : '',
    marginBottom: index < 2 ? theme.spacing(3) : '',
    borderRight: 'none',
    padding: '0px',
    paddingBottom: '24px',
  },
}));

export const DescriptionContainer = styled(Box)(({ theme, index }) => ({
  marginTop: theme.spacing(3),
  textAlign: 'center',
  minHeight: 50,
  [theme.breakpoints.down(1600)]: {
    minHeight: 70,
  },
  [theme.breakpoints.down(1300)]: {
    minHeight: 'unset',
  },
}));

export const FreeFor90Pill = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  padding: '8px 16px',
  textAlign: 'center',
  borderRadius: 50,
  marginTop: theme.spacing(3),
}));

export const PriceContainer = styled(Box)(({ theme, index }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  alignItems: 'baseline',
}));

export const ListItemsContainer = styled(Box)(({ theme, index }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(3),
}));
